import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DEVICES } from '@bitComponents/utils/constants';
import { getDeviceKindDependsOnViewPort } from '@bitComponents/utils/common';
import TextInfo, {
  TEXT_KIND,
  TEXT_COLOR,
  TEXT_ALIGN,
  TEXT_HEADING_LEVEL,
  TEXT_SIZE,
  TEXT_FONT_WEIGHT,
} from '@gcloud-npm/components.text';
import Button, {
  BUTTON_COLOR,
  BUTTON_WIDTH,
  BUTTON_HEIGHT,
} from '@bitComponents/unifiedComponents/Button';
import './NotFound.scss';

export const CONTENT_KIND = {
  ERROR: 'ERROR',
  NOT_FOUND: 'NOT_FOUND',
};

const TEXTS = {
  [CONTENT_KIND.ERROR]: {
    TITLE: '500',
    DESCRIPTION: '¡Ups! Aquí no hay nada. ¿Te rescatamos?',
    BUTTON_LABEL: 'Ir a inicio',
  },
  [CONTENT_KIND.NOT_FOUND]: {
    TITLE: '404',
    DESCRIPTION: '¡Ups! Aquí no hay nada. ¿Te rescatamos?',
    BUTTON_LABEL: 'Ir a inicio',
  }
};

const COMPONENTS_PROPS = {
  TEXT_1: {
    [DEVICES.TABLET]: {
      size: TEXT_SIZE.DISPLAY3,
      fontType: TEXT_FONT_WEIGHT.THIN,
      level: TEXT_HEADING_LEVEL.H2,
      kind: TEXT_KIND.HEADING,
      align: TEXT_ALIGN.CENTER,
      color: TEXT_COLOR.WHITE,
    },
    [DEVICES.PC]: {
      size: TEXT_SIZE.DISPLAY1,
      fontType: TEXT_FONT_WEIGHT.THIN,
      level: TEXT_HEADING_LEVEL.H2,
      kind: TEXT_KIND.HEADING,
      align: TEXT_ALIGN.CENTER,
      color: TEXT_COLOR.WHITE,
    },
  },
  TEXT_2: {
    [DEVICES.TABLET]: {
      size: TEXT_SIZE.TITLE6,
      kind: TEXT_KIND.PARAGRAPH,
      align: TEXT_ALIGN.CENTER,
      color: TEXT_COLOR.WHITE,
      fontType: TEXT_FONT_WEIGHT.REGULAR,
    },
    [DEVICES.PC]: {
      size: TEXT_SIZE.TITLE4,
      kind: TEXT_KIND.PARAGRAPH,
      align: TEXT_ALIGN.CENTER,
      color: TEXT_COLOR.WHITE,
      fontType: TEXT_FONT_WEIGHT.REGULAR,
    },
  },
  BUTTON_1: {
    [DEVICES.TABLET]: {
      color: BUTTON_COLOR.WHITE_BLUE,
      size: {
        w: BUTTON_WIDTH.MEDIUM,
        h: BUTTON_HEIGHT.LARGE,
      },
    },
    [DEVICES.PC]: {
      color: BUTTON_COLOR.WHITE_BLUE,
      size: {
        w: BUTTON_WIDTH.MEDIUM,
        h: BUTTON_HEIGHT.LARGE,
      },
    },
  },
};

const reCalculateDevice = () => {
  let currentDevice = getDeviceKindDependsOnViewPort();
  if (currentDevice === DEVICES.MOBILE) {
    currentDevice = DEVICES.TABLET;
  }

  return currentDevice;
};

class NotFound extends Component {
  state = {
    currentDevice: reCalculateDevice(),
  };

  setCurrentDevice = () => {
    this.setState({
      currentDevice: reCalculateDevice(),
    });
  };

  componentDidMount = () => {
    window.addEventListener('resize', this.setCurrentDevice);
  };

  componentWillUnmount = () => {
    window.removeEventListener('resize', this.setCurrentDevice);
  };

  render() {
    const { currentDevice } = this.state;

    const { taggingInfo, kind } = this.props;

    return (
      <div className="NotFoundContentR1">
        <TextInfo
          text={TEXTS[kind].TITLE}
          {...COMPONENTS_PROPS.TEXT_1[currentDevice]}
        />
        <TextInfo
          text={TEXTS[kind].DESCRIPTION}
          {...COMPONENTS_PROPS.TEXT_2[currentDevice]}
        />
        <Button
          label={TEXTS[kind].BUTTON_LABEL}
          {...COMPONENTS_PROPS.BUTTON_1[currentDevice]}
          link="https://www.movistar.es"
          className="rescueButton"
          taggingInfo={taggingInfo}
        />
      </div>
    );
  }
}

NotFound.PropTypes = {
  kind: PropTypes.oneOf([CONTENT_KIND.ERROR, CONTENT_KIND.NOT_FOUND]),
};

NotFound.defaultProps = {
  kind: CONTENT_KIND.NOT_FOUND,
};

export default NotFound;
